// Scroll Animation
const elements = document.querySelectorAll(".scroll-animation");
function checkScroll() {
    elements.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.85) {
            el.classList.add("visible");
        }
    });
}
window.addEventListener("scroll", checkScroll);
checkScroll();



// Thumb Animation
const thumbItems = document.querySelectorAll(".thumb-animate");
function checkVisibility() {
    thumbItems.forEach(el => {
        const rect = el.getBoundingClientRect();
        const elementHeight = rect.height;
        const visibleHeight = Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top);

        if (visibleHeight >= elementHeight * 0.4) {
            el.classList.add("in-view");
        }
    });
}
window.addEventListener("scroll", checkVisibility);
checkVisibility();



// Reveile Animation
function singleScrollReveal(className = ".reveal-group", visibleOffset = 150, delay = 300) {
    function runReveal() {
        $(className).each(function () {
            var $parent = $(this);
            var windowHeight = $(window).height();
            var elementTop = $parent.offset().top - $(window).scrollTop();

            if (elementTop < windowHeight - visibleOffset) {
                $parent.children().each(function (index) {
                    var $ele = $(this);
                    setTimeout(function () {
                        $ele.addClass("insight");
                    }, index * delay);
                });
            }
        });
    }
    $(window).on("scroll", runReveal);
    $(document).ready(runReveal);
}
singleScrollReveal();







$(document).ready(function () {
    function checkVisibility() {
        $('.fade-in-scroll').each(function () {
            var elementTop = $(this).offset().top;
            var viewportBottom = $(window).scrollTop() + $(window).height();
            if (elementTop < viewportBottom - 1) {
                $(this).addClass('is-show');
            }
        });
    }
    checkVisibility();
    $(window).on('scroll', function () {
        checkVisibility();
    });

});









$('.product-showcase__tab-items').each(function () {
    var $thisSlider = $(this);
    var type = $thisSlider.attr('data-type');
    var $dotsTarget = $thisSlider.closest('.product-showcase__wrap').find('.product-showcase__dots');
    $thisSlider.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        appendDots: $dotsTarget,
        dotsClass: 'slick-dots dots-' + type,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    adaptiveHeight: true,
                }
            }
        ]
    });
});
function showDotsFor(type) {
    var $dotsTarget = $('.product-showcase__dots');
    $dotsTarget.find('.slick-dots').removeClass('dots-active');
    $dotsTarget.find('.dots-' + type).addClass('dots-active');
}
showDotsFor($('.product-showcase__tab-items.active').attr('data-type'));
$('.product-showcase__left-arrow').on('click', function () {
    $(this).closest('.product-showcase__wrap').find('.product-showcase__tab-items.active').slick('slickPrev');
});
$('.product-showcase__right-arrow').on('click', function () {
    $(this).closest('.product-showcase__wrap').find('.product-showcase__tab-items.active').slick('slickNext');
});
$('.product-showcase__tab-button').on('click', function () {
    var type = $(this).attr('data-type');
    $('.product-showcase__tab-button').removeClass('active');
    $(this).addClass('active');
    $('.product-showcase__tab-items').removeClass('active');
    var $activeTab = $('.product-showcase__tab-items[data-type="' + type + '"]');
    $activeTab.addClass('active');
    $activeTab.slick('setPosition');
    showDotsFor(type);
});




$('.cocktail-recipes__items').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,

    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                appendDots: $('.cocktail-recipes__dots')
            }
        }
    ]
});

$('.cocktail-recipes__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});

$('.cocktail-recipes__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});











(function($) {
  var gdprCookie = Cookies.get('gdpr-loc-age');

  if (typeof gdprCookie === 'undefined') {
    if (Shopify.designMode !== true) {
      $('.location-modal').fadeIn();
      $('body').addClass('gdpr-notice-open');
    }
  } else {
    $('body').addClass(gdprCookie);
  }

  $('.location-modal__btn-url').on('click', function(e) {
    e.preventDefault();
    var $btn = $(this);
    var isDenmark = $btn.closest('.location-modal__btn').index() === 0;
    var path = location.pathname;

    if (isDenmark) {
      Cookies.set('ly-lang-selected', 'da');
      Cookies.set('gdpr-loc-age', 'den-gdpr-approved');
      $('body').addClass('den-gdpr-approved');

      if (path.indexOf('/da') !== 0) {
        window.location.href = 'https://' + location.host + '/da' + path;
        return;
      }
    } else {
      Cookies.set('gdpr-loc-age', 'row-gdpr-approved');
      $('body').addClass('row-gdpr-approved');
    }

    $('.location-modal').fadeOut();
    $('body').removeClass('gdpr-notice-open');
  });
})(jQuery);




//   document.addEventListener("DOMContentLoaded", function() {
//     (function($) {
//       var gdprCookie = Cookies.get('gdpr-loc-age');

//       // Check if the cookie exists and we aren't in the Shopify editor
//       if (typeof gdprCookie === 'undefined') {
//         if (Shopify.designMode !== true) {
//           $('.location-modal').fadeIn();
//           $('body').addClass('gdpr-notice-open');
//         }
//       } else {
//         $('body').addClass(gdprCookie);
//       }

//       // Handle the button clicks
//       $('.location-modal__btn-url').on('click', function(e) {
//         e.preventDefault();
//         var $btn = $(this);
//         var isDenmark = $btn.closest('.location-modal__btn').index() === 0;
//         var path = location.pathname;

//         if (isDenmark) {
//           Cookies.set('ly-lang-selected', 'da');
//           Cookies.set('gdpr-loc-age', 'den-gdpr-approved');
//           $('body').addClass('den-gdpr-approved');

//           if (path.indexOf('/da') !== 0) {
//             window.location.href = 'https://' + location.host + '/da' + path;
//             return;
//           }
//         } else {
//           Cookies.set('gdpr-loc-age', 'row-gdpr-approved');
//           $('body').addClass('row-gdpr-approved');
//         }

//         // Close the modal and remove the background lock
//         $('.location-modal').fadeOut();
//         $('body').removeClass('gdpr-notice-open');
//       });
//     })(jQuery);
//   });

